import React from 'react';
import Input from '../../components/Input';
import Button from '../../components/Button';
import { Grid, Icon } from 'semantic-ui-react';
import { Pushable, SideBarGrid, Logo, FormContainer, WelcomeText, Pusher, ImageBackgroundCover, ImageBackgroundText, ImageBackground } from './styles';
import backgroundcfx from '../../resources/imgs/loginImage.png';
import backgroundrv from '../../resources/imgs/background-4seg-new.png';
import logocfx from '../../resources/imgs/newlogo.png';
import logorv from '../../resources/imgs/logo.png';

interface CreatePasswordFormProps {
  password: string;
  passwordRepeat: string;
  onPasswordChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onPasswordRepeatChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
}

const CreatePasswordForm: React.FC<CreatePasswordFormProps> = ({
  password,
  passwordRepeat,
  onPasswordChange,
  onPasswordRepeatChange,
  onSubmit,
}) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const [showPasswordRepeat, setShowPasswordRepeat] = React.useState(false);

  const togglePasswordVisibility = () => setShowPassword(!showPassword);
  const togglePasswordRepeatVisibility = () => setShowPasswordRepeat(!showPasswordRepeat);

  const isRV = process.env.REACT_APP_IS_RV === 'true';
  const background = isRV ? backgroundrv : backgroundcfx;
  const logo = isRV ? logorv : logocfx;

  return (
    <Pushable>
      <SideBarGrid>
        <Logo src={logo} />
        <FormContainer>
          <div>
            <WelcomeText>Definição de senha</WelcomeText>
            <form onSubmit={onSubmit}>
              <label>SENHA:</label>
              <Input
                name='password'
                type={showPassword ? 'text' : 'password'}
                icon={
                  <Icon
                    name={showPassword ? 'eye slash' : 'eye'}
                    link
                    onClick={togglePasswordVisibility}
                  />
                }
                fluid
                onChange={onPasswordChange}
                value={password}
              />
              <p />
              <label>CONFIRMAR SENHA:</label>
              <Input
                name='passwordRepeat'
                type={showPasswordRepeat ? 'text' : 'password'}
                icon={
                  <Icon
                    name={showPasswordRepeat ? 'eye slash' : 'eye'}
                    link
                    onClick={togglePasswordRepeatVisibility}
                  />
                }
                fluid
                onChange={onPasswordRepeatChange}
                value={passwordRepeat}
              />
              <p />
              <Grid columns={2}>
                <Grid.Row>
                  <Grid.Column textAlign='center' width={16}>
                    <Button
                      text="Definir senha"
                      color='green'
                      size='large'
                      type='submit'
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </form>
          </div>
        </FormContainer>
      </SideBarGrid>

      <Pusher>
        <ImageBackground src={background} resizeMode='contain' />
      </Pusher>
    </Pushable>
  );
};

export default CreatePasswordForm;
